"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/toggle.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Toggle =
/*#__PURE__*/
function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEvent", function (event) {
      if (_this.props.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      _this.setState(function (state) {
        return {
          on: !state.on
        };
      }, function () {
        _this.props.onChange(_this.state.on);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      _this.handleEvent(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event) {
      switch (event.keyCode) {
        case 32: // SPACE

        case 13:
          // ENTER
          _this.handleEvent(event);

          break;

        default:
          break;
      }
    });

    _this.state = {
      on: props.on
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        on: nextProps.on
      });
    }
  }, {
    key: "render",
    value: function render() {
      var toggleClasses = {
        'vn-toggle': true,
        'vn-toggle--on': this.state.on,
        'vn-toggle--disabled': this.props.disabled,
        'vn-toggle--disabled--on': this.props.disabled && this.state.on
      };
      var toggleCircleClasses = {
        'vn-toggle__circle': true,
        'vn-toggle__circle--on': this.state.on,
        'vn-toggle__circle--disabled': this.props.disabled
      };
      return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: this.state.on && !this.props.disabled,
        timeout: 500,
        classNames: "vn-toggle"
      }, _react.default.createElement("a", _extends({}, this.props.id !== '' && {
        id: this.props.id
      }, {
        className: (0, _classnames.default)(toggleClasses),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        role: "switch",
        "aria-checked": this.state.on,
        tabIndex: 0
      }), this.props.disabled ? _react.default.createElement("div", {
        className: (0, _classnames.default)(toggleCircleClasses)
      }) : _react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: this.state.on,
        timeout: 500,
        classNames: "vn-toggle__circle"
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(toggleCircleClasses)
      }))));
    }
  }]);

  return Toggle;
}(_react.Component);

Toggle.propTypes = {
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  on: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
Toggle.defaultProps = {
  disabled: false,
  id: '',
  on: false,
  onChange: function onChange() {}
};
Toggle.displayName = 'Toggle';
var _default = Toggle;
exports.default = _default;